module.exports = __webpack_public_path__ + "static/media/ZIGARA-Bike.eca4b14a.png";